import {BrowserRouter as Router, Route, Routes} from 'react-router-dom';
import {AuthProvider} from "./contextos/AuthContext"
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import Objetos from './paginas/Objetos'
import Usuarios from './paginas/Usuarios'
import Culturas from './paginas/Culturas'
import Material from './paginas/Material'
import Ubicacion from './paginas/Ubicacion'
import SolicitudVisitas from './paginas/SolicitudesVisitas'
import GestionVisitas from './paginas/GestionVisitas'
import InicioSesion from './paginas/InicioSesion'
import CrearUsuario from './componentes/RegistroUsuario'
import EditarUsuario from './componentes/EditarUsuario'
import CrearCultura from './componentes/RegistroCultura'
import EditarCultura from './componentes/EditarCultura'
import CrearUbicacion from './componentes/RegistroUbicacion'
import EditarUbicacion from './componentes/EditarUbicacion'
import CrearMaterial from './componentes/RegistroMaterial'
import EditarMaterial from './componentes/EditarMaterial'
import CrearObjeto from './componentes/RegistroObjeto'
import EditarObjeto from './componentes/EditarObjeto'
import VisitasDirectas from './paginas/VisitasDirectas'
import CrearVisitaDirecta from './componentes/RegistroVisitaDirecta'
import EditarVisita from './componentes/EditarVisita'
import ConsultarVisitasDirectas from './paginas/ConsultarVisitasDirectas'
import ConsultarVisitas from './paginas/ConsultarVisitas'
import GestionPublicaciones from './paginas/Publicaciones'
import CrearPublicacion from './componentes/RegistroPublicacion'
import EditarPublicacion from './componentes/EditarPublicacion'
import GestionAutores from './paginas/Autores'
import EditarAutor from './componentes/EditarAutor'
import CrearAutor from './componentes/RegistroAutor'
import GestionTipoPublicaciones from './paginas/TipoPublicacion'
import EditarTipoPublicacion from './componentes/EditarTipoPublicacion'
import CrearTipoPublicacion from './componentes/RegistroTipoPublicacion'
import RutaPrivada from './componentes/RutaPrivada'
import Layout from './componentes/Layout'
import WebFont from 'webfontloader'

const root = ReactDOM.createRoot(document.getElementById('root'));

WebFont.load({
  google: {
    families: ['Work Sans:400,500,700', 'sans-serif']
  }
});

root.render(
  <React.StrictMode>
    <AuthProvider>
      <Router basename='/museo/app/'>
        <Routes>
            <Route path='/login' element={<InicioSesion />}/>
            
            <Route element={<Layout />}>
              <Route path='/' element={
                <RutaPrivada>
                    <App />
                </RutaPrivada>
              }/>

              <Route path='/usuarios' element={
                <RutaPrivada>
                    <Usuarios />
                </RutaPrivada>
              }/>

              <Route path='/crear-usuario' element={
                <RutaPrivada>
                    <CrearUsuario />
                </RutaPrivada>
              }/>

              <Route path='/editar-usuario/:id' element={
                <RutaPrivada>
                    <EditarUsuario />
                </RutaPrivada>
              }/>

              <Route path='/ubicacion' element={
                <RutaPrivada>
                    <Ubicacion />
                </RutaPrivada>
              }/>

              <Route path='/editar-ubicacion/:id' element={
                <RutaPrivada>
                    <EditarUbicacion />
                </RutaPrivada>
              }/>

              <Route path='/crear-ubicacion' element={
                <RutaPrivada>
                    <CrearUbicacion />
                </RutaPrivada>
              }/>

              <Route path='/culturas' element={
                <RutaPrivada>
                    <Culturas />
                </RutaPrivada>
              }/>

              <Route path='/editar-cultura/:id' element={
                <RutaPrivada>
                    <EditarCultura />
                </RutaPrivada>
              }/>

              <Route path='/crear-cultura' element={
                <RutaPrivada>
                    <CrearCultura />
                </RutaPrivada>
              }/>

              <Route path='/material' element={
                <RutaPrivada>
                    <Material />
                </RutaPrivada>
              }/>

              <Route path='/editar-material/:id' element={
                <RutaPrivada>
                    <EditarMaterial />
                </RutaPrivada>
              }/>

              <Route path='/crear-material' element={
                <RutaPrivada>
                    <CrearMaterial />
                </RutaPrivada>
              }/>

              <Route path='/objetos' element={
                <RutaPrivada>
                    <Objetos />
                </RutaPrivada>
              }/>

              <Route path='/crear-objeto' element={
                <RutaPrivada>
                    <CrearObjeto />
                </RutaPrivada>
              }/>

              <Route path='/editar-objeto/:id' element={
                <RutaPrivada>
                    <EditarObjeto />
                </RutaPrivada>
              }/>

              <Route path='/solicitudes-visita' element={
                <RutaPrivada>
                    <SolicitudVisitas />
                </RutaPrivada>
              }/>

              <Route path='/crear-visita-directa' element={
                <RutaPrivada>
                    <CrearVisitaDirecta />
                </RutaPrivada>
              }/>

              <Route path='/gestion-visita' element={
                <RutaPrivada>
                    <GestionVisitas />
                </RutaPrivada>
              }/>

              <Route path='/gestion-visitas-directas' element={
                <RutaPrivada>
                    <VisitasDirectas />
                </RutaPrivada>
              }/>

              <Route path='/crear-visita' element={
                <RutaPrivada>
                    <CrearVisitaDirecta />
                </RutaPrivada>
              }/>

              <Route path='/editar-visita/:id' element={
                <RutaPrivada>
                    <EditarVisita />
                </RutaPrivada>
              }/>

              <Route path='/consultar-visitas-directas' element={
                <RutaPrivada>
                    <ConsultarVisitasDirectas />
                </RutaPrivada>
              }/>

              <Route path='/consultar-visitas' element={
                <RutaPrivada>
                    <ConsultarVisitas />
                </RutaPrivada>
              }/>

              <Route path='/publicaciones' element={
                <RutaPrivada>
                    <GestionPublicaciones />
                </RutaPrivada>
              }/>

              <Route path='/crear-publicacion' element={
                <RutaPrivada>
                    <CrearPublicacion />
                </RutaPrivada>
              }/>

              <Route path='/editar-publicacion/:id' element={
                <RutaPrivada>
                    <EditarPublicacion />
                </RutaPrivada>
              }/>

              <Route path='/autores' element={
                <RutaPrivada>
                    <GestionAutores />
                </RutaPrivada>
              }/>

              <Route path='/crear-autor' element={
                <RutaPrivada>
                    <CrearAutor />
                </RutaPrivada>
              }/>

              <Route path='/editar-autor/:id' element={
                <RutaPrivada>
                    <EditarAutor />
                </RutaPrivada>
              }/>

              <Route path='/tipo-publicaciones' element={
                <RutaPrivada>
                    <GestionTipoPublicaciones/>
                </RutaPrivada>
              }/>

              <Route path='/crear-tipo-publicacion' element={
                <RutaPrivada>
                    <CrearTipoPublicacion />
                </RutaPrivada>
              }/>

              <Route path='/editar-tipo-publicacion/:id' element={
                <RutaPrivada>
                    <EditarTipoPublicacion />
                </RutaPrivada>
              }/>
            </Route>
        </Routes>
      </Router>
    </AuthProvider>
  </React.StrictMode>
);


